export const expensecategory = [
  {
    id: "1",
    categoryName: "Employee Benefits",
    description: "Employee Vehicle",
    isSelected: false,
  },
  {
    id: "2",
    categoryName: "Foods & Snacks",
    description: "Employee Foods",
    isSelected: false,
  },
  {
    id: "3",
    categoryName: "Entertainment",
    description: "Employee Welfare",
    isSelected: false,
  },
  {
    id: "4",
    categoryName: "Office Expenses & Postage",
    description: "Postal Expense",
    isSelected: false,
  },
  {
    id: "5",
    categoryName: "Other Expenses",
    description: "Other Expenses",
    isSelected: false,
  },
  {
    id: "6",
    categoryName: "Petrol",
    description: "Employee Cab",
    isSelected: false,
  },
  {
    id: "7",
    categoryName: "Maintenance",
    description: "Office Maintenance",
    isSelected: false,
  },
  {
    id: "8",
    categoryName: "Marketing",
    description: "Advertising Cost",
    isSelected: false,
  },
  {
    id: "9",
    categoryName: "Printing & Stationery",
    description: "Stationery Expense",
    isSelected: false,
  },
  {
    id: "10",
    categoryName: "Telephone Expense",
    description: "Telephone Cost",
    isSelected: false,
  },
];
